import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: process.env.VUE_APP_STATE_KEY,
      paths: ['auth'],
      storage: {
        getItem: key => Cookies.get(key),
        setItem: (key, value) =>
          Cookies.set(key, value, { expires: 30, secure: false }), // secure needs to be true, as soon as https is enforced on the server eb instance
        removeItem: key => Cookies.remove(key)
      }
    })
  ]
})
